require("jquery-slimscroll"); 